/* eslint-disable react/no-array-index-key */
import { StepFieldConfig } from '@/shared/components/DynamicForm/DynamicForm'
import { Step, StepLabel, Stepper as MuiStepper } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { stepperLabelStyles, stepperStyles } from './Stepper.styles'
import styles from './Stepper.module.scss'

interface SimpleStepFieldConfig {
  name: string
  label: string
}

interface StepperProps {
  setActiveStep: Dispatch<SetStateAction<number>>
  activeStep: number
  steps: StepFieldConfig[] | SimpleStepFieldConfig[]
  hasStepError?: boolean[]
  isSubmitted?: boolean
}

function Stepper({
  setActiveStep,
  activeStep,
  steps,
  hasStepError,
  isSubmitted
}: StepperProps) {
  return (
    <MuiStepper sx={stepperStyles} activeStep={activeStep} alternativeLabel>
      {steps.map((step, index) => (
        <Step
          key={`${step.name}-${index}`}
          completed={Boolean(
            isSubmitted && !hasStepError?.[index] && index !== activeStep
          )}
          onClick={() => setActiveStep(index)}
          sx={{ cursor: 'pointer' }}
        >
          <StepLabel sx={stepperLabelStyles} error={hasStepError?.[index]}>
            <p className={`${styles.stepperLabel} body-bold-small`}>
              {step.label}
            </p>
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  )
}

export default Stepper
